import React from 'react';
import Select from 'react-select';

// Material UI
import Typography from '@material-ui/core/Typography';

// Data
import { IAssessmentSelector } from './assessment-selector.interface';

const AssessmentSelector: React.FC<IAssessmentSelector> = ({
  fetchError,
  loading,
  assessmentOptions,
  activeAssessmentOption,
  onChangeAssessment,
  disabled,
}) => {
  if (fetchError) return <Typography variant="body2">Unable to load assessments at this time</Typography>;

  return (
    <Select
      isloading={loading || !activeAssessmentOption}
      isDisabled={disabled}
      options={assessmentOptions}
      onChange={option => option && onChangeAssessment(option.value)}
      value={activeAssessmentOption}
    />
  );
}

export default AssessmentSelector;
